module.exports = __webpack_public_path__ + "img/黄@3x.920cf217.png";